import React, { createContext, useCallback, useState } from 'react';

interface ModalsContext {
  content?: React.ReactNode;
  isOpen?: boolean;
  onOpen: (content: React.ReactNode, key?: string) => void;
  onCancel: () => void;
}

export const Context = createContext<ModalsContext>({
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onOpen: () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onCancel: () => {},
});

const Modals: React.FC = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [content, setContent] = useState<React.ReactNode>();
  const [modalKey, setModalKey] = useState<string>();

  const handlePresent = useCallback(
    (modalContent: React.ReactNode, key?: string) => {
      setModalKey(key);
      setContent(modalContent);
      setIsOpen(true);
    },
    [setContent, setIsOpen, setModalKey],
  );

  const handleDismiss = useCallback(() => {
    if (React.isValidElement(content)) {
      if (content.props.onCancel) {
        content.props.onCancel();
      }
    }
    setContent(undefined);
    setIsOpen(false);
  }, [setContent, setIsOpen, modalKey]);

  return (
    <Context.Provider
      value={{
        content,
        isOpen,
        onOpen: handlePresent,
        onCancel: handleDismiss,
      }}
    >
      {children}
      {isOpen &&
        React.isValidElement(content) &&
        React.cloneElement(content, {
          onCancel: handleDismiss,
          openSelf: handlePresent,
        })}
    </Context.Provider>
  );
};

export default Modals;
